module.exports = __webpack_public_path__ + "static/media/12.c7bf5e1c.mp3";